"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/role.ts
var _role = require('@ariakit/react-core/role/role');



exports.Role = _role.Role;
